<template>
  <section id="start">
    <section id="intro">
      <div class="hero">
        <h1>Individuelle Web-Entwicklung nach Ihrem Design zum Pauschalpreis.</h1>
        <rounded-button link="/templates" btn-text="Jetzt konfigurieren" btn-color="white" btn-icon="plus" />
      </div>
    </section>
    <section class="teaser teaser-grey">
      <section class="teaser-section">
        <div class="half">
          <h2 class="small-centered">Wer profitiert von clickzip?</h2>
          <p class="small-centered">clickzip befähigt jeden, Websites zu verkaufen - ganz ohne Programmierkenntnisse.</p>
          <rounded-button link="/templates" btn-text="Jetzt konfigurieren" btn-color="blue" btn-icon="plus" />
        </div>
        <div class="half">
          <div class="who" :class="{whoActive: whoCreative}">
            <div class="who-header" @click="toggleWho('whoCreative')">
              <h3>Kreative</h3><img src="../assets/img/icons/closeSlideDown.svg" alt="Details für Kreative" />
            </div>
            <transition name="who-transition">
              <div class="who-body" v-if="whoCreative">
                <p>clickzip befähigt kreative Köpfe, auch ohne Programmierkenntnisse ihre individuellen Designs zu digitalen Produkten werden zu lassen. Web-Design ist jetzt so einfach wie Print-Design - gestalten, bestellen, fertig.</p>
              </div>
            </transition>
          </div>
          <div class="who" :class="{whoActive: whoAgency}">
            <div class="who-header" @click="toggleWho('whoAgency')">
              <h3>Agenturen</h3><img src="../assets/img/icons/closeSlideDown.svg" alt="Details für Agenturen" />
            </div>
            <transition name="who-transition">
              <div class="who-body" v-if="whoAgency">
                <p>Agenturen können sich voll auf ihre Stärken konzentrieren und das Programmieren ganz oder teilweise auslagern. clickzip befreit Agenturen von Fixkosten, gibt Flexibilität in der Projektplanung und bietet immer eine gleichbleibende hohe Qualität.</p>
              </div>
            </transition>
          </div>
          <div class="who" :class="{whoActive: whoMarketing}">
            <div class="who-header" @click="toggleWho('whoMarketing')">
              <h3>Marketingabteilungen</h3><img src="../assets/img/icons/closeSlideDown.svg" alt="Details für Marketingabteilungen" />
            </div>
            <transition name="who-transition">
              <div class="who-body" v-if="whoMarketing">
                <p>Beschäftigt Ihre Marketingabteilung eigene Designer? Dann können Sie jetzt mit clickzip neue Web-Projekte ebenso selbst umsetzen, wie zuvor Printprodukte oder digitale Dokumente.</p>
              </div>
            </transition>
          </div>
        </div>
      </section>
    </section>
    <section class="teaser teaser-blue">
      <section class="teaser-section">
        <div class="half no-small">
          <div class="step-image">
            <img v-if="showConfig" src="../assets/img/icons/howto/funktionen-konfigurieren.svg" alt="Mit clickzip Funktionen konfigurieren" />
            <img v-if="showOffer" src="../assets/img/icons/howto/angebot-erhalten.svg" alt="Von clickzip ein kostenloses Angebot erhalten" />
            <img v-if="showDesign" src="../assets/img/icons/howto/design-hochladen.svg" alt="Ihr individuelles Design hochladen" />
            <img v-if="showProg" src="../assets/img/icons/howto/wir-programmieren.svg" alt="clickzip programmiert Ihre Website" />
          </div>
        </div>
        <div class="half explains">
          <h2>So einfach geht's</h2>
          <section class="step-explain" :class="{stepActive: showConfig}" @click="toggleImg('showConfig')">
            <h3 class="imgconfig">1. Konfigurieren</h3>
            <p>Konfigurieren Sie den Funktionsumfang der Kunden-Website. Sie sehen sofort einen Pauschalpreis.</p>
          </section>
          <section class="step-explain" :class="{stepActive: showOffer}" @click="toggleImg('showOffer')">
            <h3 class="imgoffer">2. Angebot erhalten</h3>
            <p>Sie erhalten ein kostenloses und völlig unverbindliches Angebot. Nehmen Sie sich Zeit, das Angebot zu prüfen.</p>
          </section>
          <section class="step-explain" :class="{stepActive: showDesign}" @click="toggleImg('showDesign')">
            <h3 class="imgdesign">3. Design hochladen</h3>
            <p>Laden Sie Ihr individuelles Design hoch. Bei uns gibt es kein Design von der Stange.</p>
          </section>
          <section class="step-explain" :class="{stepActive: showProg}" @click="toggleImg('showProg')">
            <h3 class="imgprog">4. Wir erledigen den Rest</h3>
            <p>Ihr individuelles Design wird zu einer Website für ein Content Management System. Sie benötigen keinerlei Programmierkenntnisse, um Ihren Kunden professionelle Websites zu verkaufen.</p>
          </section>
          <br>
          <rounded-button link="/templates" btn-text="Jetzt konfigurieren" btn-color="white" btn-icon="plus" />
        </div>
      </section>
    </section>
    <section class="teaser">
      <section class="teaser-section">
        <section class="full">
          <h2>Gute Gründe, warum Sie sich für clickzip entscheiden sollten</h2>
          <ul>
            <li>Transparente und pauschale Preisgestaltung ohne versteckte Kosten</li>
            <li>Persönlicher Ansprechpartner über den gesamten Projektzeitraum</li>
            <li>Für Ihre Kunden unsichtbar: Ihre Kunden bekommen nicht mit, dass Sie Ihre Entwicklung auslagern</li>
            <li>Attraktive Rabatte und Boni für Großkunden: Sprechen Sie uns darauf an</li>
            <li>Einsatz modernster Technologien und Programmierung auf professionellstem Niveau</li>
            <li>Alle Angebote sind völlig unverbindlich und kostenlos</li>
            <li>Attraktive Zahlungsmodalitäten: Keine Anzahlungen - stattdessen faire, nachvollziehbare Milestones</li>
            <li>Open Source und offene Standards: Die Website kann problemslos erweitert werden</li>
          </ul>
          <rounded-button link="/templates" btn-text="Jetzt konfigurieren" btn-color="blue" btn-icon="plus" />
        </section>
      </section>
    </section>
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
import RoundedButton from '@/components/RoundedButton.vue'
import HowTo from '@/components/HowTo.vue'
export default {
  name: 'start',
  components: {
    HowTo,
    RoundedButton,
    InclusiveFooter,
    Made
  },
  data: function () {
    return {
      showConfig: true,
      showOffer: false,
      showDesign: false,
      showProg: false,
      //
      whoCreative: true,
      whoAgency: false,
      whoMarketing: false
    }
  },
  methods: {
    toggleImg: function (toggleThis) {
      this.showConfig = false
      this.showOffer = false
      this.showDesign = false
      this.showProg = false
      switch (toggleThis) {
        case 'showConfig':
          this.showConfig = true
          break
        case 'showOffer':
          this.showOffer = true
          break
        case 'showDesign':
          this.showDesign = true
          break
        case 'showProg':
          this.showProg = true
          break
      }
    },
    toggleWho: function (toggleThis) {
      this.whoCreative = false
      this.whoAgency = false
      this.whoMarketing = false
      switch (toggleThis) {
        case 'whoCreative':
          this.whoCreative = true
          break
        case 'whoAgency':
          this.whoAgency = true
          break
        case 'whoMarketing':
          this.whoMarketing = true
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#start {
  h1 {
    font-family: $primaryFont;
    font-weight: $primaryFontSemiBold;
    color: $primaryFontColor;
    letter-spacing: 0.4px;
    font-size: 30px;
    color: #fff;
  }
  height: 100%;
  min-height: 420px;
  .teaser {
    padding: 6vh 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    min-height: 100%;
    background: #fff;
    .teaser-section {
      .who {
        z-index: 1;
        top:0;
        position: relative;
        .who-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 20px;
          transition: padding 0.2s ease-in-out;
          border-bottom: 2px solid #eee;
          hyphens: auto;
          &:hover {
            cursor: pointer;
          }
          img {
            width: 20px;
            height: auto;
            flex-shrink: 0;
            margin-left: 10px;
          }
        }
        .who-body {
          padding: 0 20px 10px 20px;
          font-size: 18px;
          letter-spacing: 0.2px;
          position: absolute;
          display: none;
        }
        &.whoActive {
          z-index: 2;
          top: -2px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
          background: #fff;
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
          .who-header {
            padding: 20px 20px 10px 20px;
            border-top: 4px solid $primaryColor;
            border-bottom: none;
            &:hover {
              cursor: auto;
            }
            img {
              transform: rotate(180deg) translateY(3px);
            }
          }
          .who-body {
            position: relative;
            display: block;
          }
        }
        &:first-child {
          margin-top:30px;
        }
        &:last-child {
          &.whoActive {
            .who-header {
              border-top: 4px solid $primaryColor;
              border-bottom: none;
            }
          }
          .who-header {
            border-bottom: none;
          }
        }
      }
      .step-explain {
        margin-left: 60px;
        margin-top: 40px;
        margin-bottom: 40px;
      }
      img {
        width: auto;
        max-width: 100%;
        height: auto;
      }
      h2 {
        font-family: $primaryFont;
        font-weight: $primaryFontSemiBold;
        color: $primaryFontColor;
        font-size: 28px;
        margin-bottom: 20px;
      }
      h3 {
        font-family: $primaryFont;
        font-weight: $primaryFontSemiBold;
        color: $primaryFontColor;
        font-size: 20px;
        margin-bottom: 4px;
        position: relative;
        &:before {
          display: block;
          content: '';
          width: 46px;
          height: 46px;
          position: absolute;
          left: -60px;
          top: -4px;
          background-position: center;
          background-size: 46px 46px;
        }
      }
      .imgconfig {
        &:before {
          background-image: url('../assets/img/icons/howto/funktionen-konfigurieren.svg');
        }
      }
      .imgoffer {
        &:before {
          background-image: url('../assets/img/icons/howto/angebot-erhalten.svg');
        }
      }
      .imgdesign {
        &:before {
          background-image: url('../assets/img/icons/howto/design-hochladen.svg');
        }
      }
      .imgprog {
        &:before {
          background-image: url('../assets/img/icons/howto/wir-programmieren.svg');
        }
      }
      p {
        font-family: $secondaryFont;
        font-weight: $secondaryFontNormal;
        color: $primaryFontColor;
        font-size: 18px;
      }
      ul {
        font-family: $secondaryFont;
        font-weight: $secondaryFontNormal;
        color: $primaryFontColor;
        margin: 25px 0 35px 0;
        padding: 0 0 0 22px;
        li {
          list-style: none;
          position: relative;
          font-size: 18px;
          margin-bottom: 10px;
          padding-left: 5px;
        }
        li:before {
          content:'';
          display:inline-block;
          background-position:center center;
          background-repeat:no-repeat;
          margin-right:8px;
          position: absolute;
          top: 7px;
          left: -22px;
          width: 16px;
          height: 16px;
          background-image: url('../assets/img/icons/listCheckBlue.svg');
        }
      }
      .btn {
        text-align: center;
      }
      margin: 11vh 0;
      min-height: 60%;
      width: 100%;
      max-width: 1200px;
      padding: 0 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .big {
        width: 100%;
      }
      .small {
        width: 100%;
      }
      .half {
        width: 100%;
      }
      .no-small {
        display: none;
      }
      .small-centered {
        text-align: center;
      }
    }
  }
  .teaser-grey {
    background: #fbfbfb;
  }
  .teaser-blue {
    background: $primaryColor;
    color: #fff;
    .teaser-section {
      h1,
      h2,
      h3,
      p {
        color: #fff;
      }
    }
  }
}
@media (min-width:300px) {
  #start {
    .teaser {
      .teaser-section {
        .step-explain {
          margin-left: auto;
          margin-right: auto;
        }
        .explains {
          h2,
          h3,
          p {
            text-align: center;
          }
          h3 {
            margin-top: 190px;
            &:before {
              left: 50%;
              transform: translateX(-50%);
              top: 150px;
              width: 110px;
              height: 110px;
              background-size: 110px;
              top: -135px;
            }
          }
        }
      }
    }
  }
}
@media (min-width:440px) {
  #start {
    .teaser {
      .teaser-section {
        .step-explain {
          max-width: 400px;
        }
        .explains {
          h3 {
            margin-top: 210px;
            &:before {
              top: 180px;
              width: 140px;
              height: 140px;
              background-size: 140px;
              top: -165px;
            }
          }
        }
      }
    }
  }
}
@media(min-width:767px) {
  #start {
    h1 {
      font-size: 34px;
    }
    .teaser {
      .teaser-section {
        .explains {
          h2,
          h3,
          p {
            text-align: left;
          }
        }
        .step-image {
          img {
            margin: 0 40px;
            max-width: 100%;
          }
        }
        .step-explain {
          margin: 8px 0 8px 0;
          padding: 10px 20px 1px 20px;
          border-radius: 12px;
          position: relative;
          left: -20px;
          width: 100%;
          width: calc(100% + 20px);
          transition: background 0.1s ease-in;
          p {
            font-size: 18px;
          }
          h3 {
            margin-top: 0;
            &:before {
              display: none;
            }
          }
          &:hover,
          &.stepActive {
            background: #6F8AFF;
            cursor: pointer;
          }
        }
        h2 {
          font-size: 28px;
        }
        h3 {
          font-size: 20px;
        }
        .btn {
          text-align: left;
        }
        padding: 0 40px;
        flex-wrap: nowrap;
        .big {
          width: 60%;
          padding: 0 15px;
        }
        .small {
          width: 40%;
          padding: 0 15px;
        }
        .half {
          width: 50%;
          padding: 0 15px;
        }
        .no-small {
          display: block;
        }
        .small-centered {
          text-align: left;
        }
      }
    }
  }
}
@media (min-width: 960px) {
  #start {
    h1 {
      font-size: 36px;
    }
    .teaser {
      .teaser-section {
        .step-image {
          img {
            margin: 0 80px 0 25px;
          }
        }
        h2 {
          font-size: 30px;
        }
        h3 {
          font-size: 20px;
        }
      }
    }
  }
}
@media (min-width: 1200px) {
  #start {
    .teaser {
      .teaser-section {
        .who {
          .who-body {
            p {
              font-size: 20px;
            }
          }
        }
        h1 {
          font-size: 42px;
        }
        ul {
          margin: 30px 0 40px 0;
          li {
            font-size: 20px;
            margin-bottom: 10px;
            padding-left: 10px;
            &:before {
              top: 8px;
              left: -22px;
              width: 18px;
              height: 18px;
            }
          }
        }
        .step-image {
          img {
            margin: 0 105px 0 35px;
          }
        }
        .step-explain {
          padding: 20px 20px 10px 20px;
          p {
            font-size: 20px;
          }
        }
        h2 {
          font-size: 32px;
        }
        h3 {
          font-size: 22px;
        }
        p {
          font-size: 20px;
        }
      }
    }
  }
}
#intro {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-image: url('../assets/img/introBg.jpg');
  .hero {
    max-width: 920px;
    span {
      text-align: left;
    }
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.who-transition-enter-active {
  transition: all 0.2s ease-in-out;
}
.who-transition-leave-active {
  transition: all 0.1s;
}
.who-transition-enter, .who-transition-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(3px);
  opacity: 0;
}
</style>
